<template>
	<div>
		<block v-if="loading"></block>
		<v-card flat class="pa-4 bar">
			<div class="d-flex justify-end align-center">
				<v-btn 
					small 
					class="btn-save"
					@click="printPreview"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
			</div>
		</v-card> 

		<v-row class="mx-1 mt-5">
			<v-col cols="12" md="5">
				<v-select
					v-model="search.month"
					:items="monthList"
					item-text="text"
					item-value="value"
					label="Mes"
					outlined
					attach
					dense
				></v-select>
			</v-col>
			<v-col cols="12" md="5">
				<v-text-field
					v-model="search.year"
					label="Año"
					outlined
					type="number"
					attach
					dense
					clearable
				></v-text-field>
			</v-col>
			<v-col cols="12" md="2">
				<v-btn 
					small 
					class="btn-save"
					@click="getResultsStatement"
				>
					Buscar Movimientos
				</v-btn>
			</v-col>
		</v-row>

		<v-container fluid class="mx-1 mt-2">
			<v-row>
				<v-radio-group v-model="BalanceType" row>
					<v-radio label="Mensual" :value="1"></v-radio>
					<v-radio label="Acumulado" :value="2"></v-radio>
				</v-radio-group>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<div
						v-bind="attrs"
						v-on="on"
						class="d-inline-block"
					>
						<v-checkbox
							v-model="notToCalculateLegalReserve"
							label="No calcular Reserva Legal al Imprimir"
							class="ml-4"
						/>
						</div>
					</template>
					<span>Se mostrará el saldo actual de la cuenta de reserva legal</span>
				</v-tooltip>
				
			</v-row>
		</v-container>

		<v-row>
			<p style="margin: 20px 0 -4px 16px; font-weight: 600;">ACTIVOS</p>
			<DxDataGrid 
				:dataSource="DataTable"
				:showBorders="true"
				:scrolling="{ useNative: true }"    
				:column-auto-width="true"
			>
				<DxColumn dataField="account_code" caption="Código de Cuenta" />
				<DxColumn dataField="account_description" caption="Descripción de la Cuenta" />
				<DxColumn dataField="SubAccountsBalanceFormatted" caption="Saldo de SubCuenta" />
				<DxColumn dataField="MajorAccountsBalanceFormatted" caption="Saldo de Cuenta de Mayor" />
				<DxColumn dataField="HeaderAccountsBalanceFormatted" caption="Saldo de Cuenta de Rubro" />
				
				<DxPager :showPageSizeSelector="true" :allowedPageSizes="[5, 10, 20]" />
				<DxPaging :defaultPageSize="10" />
			</DxDataGrid>
		</v-row>
		<v-row>
			<v-col offset="8" md="4">
				<p style="float:left; margin-right: 140px; text-align: right;">TOTAL:</p><p style="overflow: hidden; text-align: right;"> {{ this.getTotal() }}</p>
			</v-col>
		</v-row>
		
		<alerts
			v-if="alert.show"
			v-on:close_alert="closeAlert"
			v-on:accept_alert="acceptAlert"
			:properties="alert"
		></alerts>

		<PrintResultsStatementsReport :dataProps="print" :balanceDate="balanceDate"></PrintResultsStatementsReport>
	</div>
</template>

<script>
import Block from "@/components/Block";
import {DxDataGrid, DxPager, DxPaging, DxColumn} from 'devextreme-vue/data-grid';
import alerts from '@/components/Alerts.vue';
import PrintResultsStatementsReport from '../../../components/ReportsAndPrintings/PrintResultsStatementsReport.vue';
import moment from 'moment';
import { numberWithCommas } from "../../../helpers/money";

export default {
	name: "SheetCheckBalanceAnnex",
	components: {
		DxDataGrid,
		DxPager,
		DxPaging,
		DxColumn,
		alerts,
		PrintResultsStatementsReport,
		Block
	},
	props: ['win'],
	data() {
		return {
			notToCalculateLegalReserve: false,
			currencySymbol: JSON.parse( localStorage.getItem( 'branch' ) ).Currency,
			DataTable: [],
			BalanceType: 1,
			search:{
				month: '',
				year: `${new Date().getFullYear()}`,
			},
			typesDitionary: {
				1: 'Mensual',
				2: 'Acumulado',
			},
			alert: {
				type: "success",
				show: false,
				header: "",
				body: "",
			},
			loading: false,
			recordsetForReport: [],
			monthList: [
				{text: 'Enero', value: 1},
				{text: 'Febrero', value: 2},
				{text: 'Marzo', value: 3},
				{text: 'Abril', value: 4},
				{text: 'Mayo', value: 5},
				{text: 'Junio', value: 6},
				{text: 'Julio', value: 7},
				{text: 'Agosto', value: 8},
				{text: 'Septiembre', value: 9},
				{text: 'Octubre', value: 10},
				{text: 'Noviembre', value: 11},
				{text: 'Diciembre', value: 12},
			],
			print: {
				show: false,
				data: []
			},
		}
	},
	computed:{
		balanceDate() {
			return '27 de Agosto de 2024'
		}
	},
	watch: {
		BalanceType() {
			this.cleanData()
		},
	},
	methods: {
		cleanData() {
			this.DataTable = []
		},
		closeAlert() {
			this.alert.show = false;
		},
		acceptAlert() {
			this.alert.show = false;
		},
		showAlert(type, header, body, options = null) {
			type = type == null ? "danger" : type;
			this.alert.type = type;
			this.alert.header = header;
			this.alert.body = body;
			this.alert.show = true;
			this.alert.options = options != null ? options : null;
		},
		async getResultsStatement(){
			this.loading = true;
			try {
				this.cleanData();
				
				if(this.search.month == null || this.search.year == null){
					this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
					return;
				}

				const currentYear = new Date().getFullYear();
				if(this.search.year.length != 4 && this.search.year > currentYear){
					this.showAlert("danger", "Error", "Ingrese una fecha válida");
					return;
				}
				const response = await this.$API.accountingreports.getResultsStatement( { ...this.search, type: this.BalanceType } );
				
				const recordset = [];
				
				for( const element in response.data ) {
					recordset.push( ...response.data[ element ] )
				}
				this.recordsetForReport = response.data;

				this.validateLengthOfReport( recordset, "El periodo solicitado no posee registros contables", () => {
					this.DataTable = recordset;
				} );
			} catch (error) {
				this.showAlert(
					"warning",
					"No fue posible consultar los datos",
					"Vuelva a intentarlo y si el problema persiste comuniquese con su administrador"
				);
			} finally {
				this.loading = false;
			}
		},
		getTotal() {
            let accum = 0.00;
            for( const record of this.DataTable ) {
				if( record.IsFirst === 1 ) {
					accum += record.CurrentBalance ? record.CurrentBalance : 0;
				}
			}
            return `${ this.currencySymbol }${ numberWithCommas( accum ) }`;
        },
		validateLengthOfReport( data, message, next ) {
			if( data && !data.length  ) {
				this.showAlert(
					"warning",
					"No se encontraron datos",
					message
				);
			} else {
				next();
			}
		},
		printPreview() {
			//console.log('data', this.DataTable);
			this.validateLengthOfReport( this.DataTable, "No hay datos que imprimir", () => {
				moment.locale('es_SV');
	
				const currentDate = moment();
	
				currentDate.set( 'month', this.search.month - 1 );
				currentDate.set( 'year', this.search.year );
	
				let currentMonth = currentDate.startOf("month").format('MMMM');
	
				currentMonth = `${ currentMonth.substring( 0, 1 ).toUpperCase() }${ currentMonth.substring( 1, currentMonth.length ) }`;

				let firstDay = currentDate.startOf("month").format('DD');

				let lastDay = currentDate.endOf('month').format('DD');
	
				let balanceHeader = '';
				if( this.BalanceType === 1 ) {
					balanceHeader = `REPORTE DE ESTADO DE RESULTADOS DEL ${firstDay} AL ${lastDay} DE ${ currentMonth.toUpperCase() } DE ${ currentDate.year() }`;				
				} else {
					balanceHeader = `REPORTE DE ESTADO DE RESULTADOS AL ${lastDay} DE ${ currentMonth.toUpperCase() } DE ${ currentDate.year() }`;				
				}
	
				this.print = {
					show: true,
					data: {
						records: this.recordsetForReport,
						monthOfRequest: currentDate.startOf("month").format('MM'),
						notToCalculateLegalReserve: this.notToCalculateLegalReserve,
						//userData: userData,
					},
					balanceHeader,
					balanceType: this.typesDitionary[ this.BalanceType ],
				}
			} )
		},
	},
}
</script>

<style scoped>
	.book-radio {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
		font-size: 16px;
		color: black;
		margin: 0 0 20px 12px;
	}
	.book-radio label {
		cursor: pointer;
	}
	.book-radio input[type="radio"] {
		display: none;
	}
	.book-radio .custom-radio {
		width: 20px;
		height: 20px;
		border: 2px solid #777;
		border-radius: 50%;
		display: inline-block;
		position: relative;
		cursor: pointer;
		transition: background-color 0.3s;
		align-self: center;
	}
	.book-radio .custom-radio::before {
		content: '';
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		transition: background-color 0.3s;
	}
	.book-radio input[type="radio"]:checked + .custom-radio::before {
		background-color: #3498DB;
	}
	.book-radio label {
		display: flex;
		gap: 8px;
		align-items: center;
	}
	.bar {
		max-width: 100%;
		background-color: rgb(60, 60, 60) !important;
		color: white !important;
		border-style: solid;
		border-color: black;
		border-radius: 15px !important;
		margin: 16px 12px !important;
	}
	.btn-add{
		background-color: #3498DB  !important;
		color: white;
	}
	.btnsave{
		background-color: #00A178 !important;
		color: white;
	}
</style>